import { render, staticRenderFns } from "./dyh-goodsSearch.vue?vue&type=template&id=f2949182&scoped=true&"
import script from "./dyh-goodsSearch.vue?vue&type=script&lang=js&"
export * from "./dyh-goodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./dyh-goodsSearch.vue?vue&type=style&index=0&id=f2949182&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2949182",
  null
  
)

export default component.exports